import axios from 'axios';

const BASE_URL = import.meta.env.VITE_NODE_API_URL;

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to add auth token from Clerk
api.interceptors.request.use(
  async (config) => {
    try {
      // Get token from Clerk if user is authenticated
      let token = null;

      // Check if we're in a browser environment and Clerk is available
      if (typeof window !== 'undefined' && window.Clerk) {
        try {
          // Try to get token from the session
          if (window.Clerk.session) {
            token = await window.Clerk.session.getToken();
          }
        } catch (tokenError) {
          console.warn('Could not get token from Clerk session:', tokenError);
          // Fallback: try to get token directly from the user if available
          if (window.Clerk.user) {
            try {
              token = await window.Clerk.user.getToken();
            } catch (userTokenError) {
              console.warn('Could not get token from Clerk user:', userTokenError);
            }
          }
        }
      }

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        console.warn('No authentication token available for API request');
      }

      return config;
    } catch (error) {
      console.error('Error adding auth token to request:', error);
      // Don't reject the request, just proceed without token
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
